import { render, staticRenderFns } from "./LabSettingsView.vue?vue&type=template&id=019159f2&scoped=true&"
import script from "./LabSettingsView.vue?vue&type=script&lang=js&"
export * from "./LabSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./LabSettingsView.vue?vue&type=style&index=0&id=019159f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019159f2",
  null
  
)

export default component.exports